import React from 'react';
import { Home, Package, Bell, User } from 'lucide-react';
interface BottomNavProps {
  onNetworkClick?: () => void;
  onInventoryClick?: () => void;
  onRMIClick?: () => void;
  onNotificationsClick?: () => void;
  activeNav?: 'rmi' | 'inventory' | 'network' | 'notifications' | 'profile' | null;
}
export function BottomNav({
  onNetworkClick,
  onInventoryClick,
  onRMIClick,
  onNotificationsClick,
  activeNav = null
}: BottomNavProps) {
  return <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-100 safe-bottom z-50 w-full" data-id="element-16">
      <div className="w-full mx-auto px-2 pt-2 pb-1" data-id="element-17">
        <div className="flex justify-between items-end relative" data-id="element-18">
          {/* Left Group */}
          <div className="flex-1 flex justify-around" data-id="element-19">
            <button onClick={onRMIClick} className={`flex flex-col items-center gap-1 relative py-1 ${activeNav === 'rmi' ? 'text-secondary' : 'text-gray-400 hover:text-gray-600'}`} data-id="element-20">
              <Home className="w-6 h-6" strokeWidth={1.5} data-id="element-21" />
              <span className="text-[10px] font-medium" data-id="element-22">RMI</span>
              <span className="absolute top-0 right-3 w-2 h-2 bg-red-500 rounded-full border border-white" data-id="element-23"></span>
            </button>

            <button onClick={onInventoryClick} className={`flex flex-col items-center gap-1 relative py-1 ${activeNav === 'inventory' ? 'text-secondary' : 'text-gray-400 hover:text-gray-600'}`} data-id="element-24">
              <Package className="w-6 h-6" strokeWidth={1.5} data-id="element-25" />
              <span className="text-[10px] font-medium" data-id="element-26">Inventory</span>
              <span className="absolute top-0 right-4 w-2 h-2 bg-red-500 rounded-full border border-white" data-id="element-27"></span>
            </button>
          </div>

          {/* Center FAB Container */}
          <div className="relative -top-6 mx-2" data-id="element-28">
            <button onClick={onNetworkClick} className="w-14 h-14 rounded-full bg-gradient-to-br from-primary to-accent flex items-center justify-center shadow-lg shadow-primary/30 text-white transform transition-transform active:scale-95" data-id="element-29">
              <img src="https://cdn.magicpatterns.com/uploads/ompKNW2ZKiat5oXcKrq3mX/white_logo_.svg" alt="Network" className="w-7 h-7" data-id="element-30" />
            </button>
            <div className="text-center mt-1" data-id="element-31">
              <span className={`text-[10px] font-medium ${activeNav === 'network' ? 'text-secondary' : 'text-neutral-text'}`} data-id="element-32">
                Network
              </span>
            </div>
          </div>

          {/* Right Group */}
          <div className="flex-1 flex justify-around" data-id="element-33">
            <button onClick={onNotificationsClick} className={`flex flex-col items-center gap-1 relative py-1 ${activeNav === 'notifications' ? 'text-secondary' : 'text-gray-400 hover:text-gray-600'}`} data-id="element-34">
              <Bell className="w-6 h-6" strokeWidth={1.5} data-id="element-35" />
              <span className="text-[10px] font-medium" data-id="element-36">Notifications</span>
              <span className="absolute top-0 right-5 w-2 h-2 bg-red-500 rounded-full border border-white" data-id="element-37"></span>
            </button>

            <button className={`flex flex-col items-center gap-1 py-1 ${activeNav === 'profile' ? 'text-secondary' : 'text-gray-400 hover:text-gray-600'}`} data-id="element-38">
              <User className="w-6 h-6" strokeWidth={1.5} data-id="element-39" />
              <span className="text-[10px] font-medium" data-id="element-40">Profile</span>
            </button>
          </div>
        </div>
      </div>
    </div>;
}